import { useMemo } from 'react';
import type { IdentityProviderModel } from '@hotjar/webapp/domains/sso/model';

export const hasSSOConnection = (
  idpData: IdentityProviderModel[],
  organizationId: number | null,
): boolean =>
  organizationId
    ? idpData.some((idp) => idp.organizations.some((org) => org.id === organizationId))
    : false;

export const useHasSSOConnection = (
  idpData: IdentityProviderModel[],
  organizationId: number | null,
): boolean => {
  return useMemo(() => hasSSOConnection(idpData, organizationId), [idpData, organizationId]);
};
